// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_ut8","cls2":"Base-cls2_7te Base-cls1_ut8"};